var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgTableware = function SvgTableware(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71,93.9085714 C70.9921918,97.6383211 70.0928676,100.006331 66.7555391,100 C63.4237221,99.9921515 62.6948011,97.6094729 62.7026093,93.8772784 L62.5969686,58.5474345 C62.475252,58.5621031 53.1430415,57.1954736 50,47.1963412 C50,47.1963412 53.8251132,-0.0376046149 68.1976728,0 C71.866162,0.00835717468 70.817563,10.3391968 70.817563,10.3391968 L71,93.9085714 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3998848,46.1076688 L17.6974977,46.1076688 L20.0973888,93.8814658 C20.0973888,97.6175791 16.9334118,100 13.5988011,100 C10.2641904,100 7.2744287,97.6175791 7.2744287,93.8814658 L9.77056529,46.1536729 L7.97009598,46.1159887 C6.60245567,46.1159887 0,33.205305 0,30.9501296 L3.10134403,0 C3.10942569,0.039641755 7.44680735,0.181569079 7.44680735,0.181569079 L7.38619474,20.5615426 C7.38619474,22.908726 7.32741887,24.710713 9.5159006,24.710713 C11.7041069,24.710713 11.735607,22.9065728 11.735607,20.5615426 L11.7356069,0.181568981 L17.7013547,0.181568981 L17.7013547,20.8331619 C17.7013547,23.1800518 17.9892645,24.6774334 20.1777463,24.6774334 C22.366228,24.6774334 22.3290339,23.1801497 22.3290339,20.8331619 L22.3290339,0.181568981 C22.3290339,0.181568981 25.7575022,0.181568981 25.949442,0.181568981 L29,30.9501296 C29,33.224196 20.7498924,46.1076688 19.3998848,46.1076688 Z"
  }))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgTableware);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "tableware.4c04265804d393feda6bdc81e792cae9.svg";